import React from "react";
import styled from "styled-components";
import { Icon } from "@solarwinds-cloud/cloud-ui";

export const ListHeading = styled.div`
  font-size: ${p => p.theme.ContractDetails.ListHeading.fontSize};
  margin-top: ${p => (p.modal ? "5px" : p.theme.ContractDetails.margin)};
  line-height: ${p => p.theme.ContractDetails.ListHeading.lineHeight};
  color: ${p => p.theme.ContractDetails.ListHeading.color};
  width: 100%;
  margin-bottom: 5px;
`;

const CheckWrapper = styled.div`
  display: inline-block;
  font-size: 25px;
  margin-right: 5px;
  i {
    left: -4px;
    position: relative;
    top: 5px;
    width: 18px !important;
  }
`;

const ListLineDiv = styled.div`
  color: ${p => p.theme.ContractDetails.ListLine.color};
  line-height: ${p => p.theme.ContractDetails.ListLine.lineHeight};
  display: flex;
  align-items: center;
`;

const StatusCheck = ({ negative }) => (
  <CheckWrapper>
    {negative ? (
      <Icon name="remove" color="red" />
    ) : (
      <Icon name="check" color="green" />
    )}
  </CheckWrapper>
);

const ListLine = ({ children, negative }) => (
  <ListLineDiv>
    <StatusCheck negative={negative} /> {children}
  </ListLineDiv>
);

export default ListLine;
